module.exports = __webpack_public_path__ + "img/niu15.05166890.jpg";